module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAANCAYAAACQN/8FAAAAAXNSR0IArs4c6QAAAKNJREFUKBVjYMAC/v//HwDE0likUIWAihYD8R4gZkSVQeMBFQgB8WMgLkGTwuQCFTkC8XcgNsSURRMBKuoA4utAzMkIJPSA8jpoamBcNiBjIhAvYQAqbAJiQuA5yESQLnaYEWg0KIhOAnEBmjiCCzQAZMheIF6NEMXCAiooBWJQEAlikYYIASUNgRgUNI44FYEkgAo2AHEnXkVQhcpAhSBPwgEAqhmMhwZU+5MAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/layouts/PageLayout/assets/up-arrow-webpage-path.png
// module id = ./src/layouts/PageLayout/assets/up-arrow-webpage-path.png
// module chunks = 1